import { AloftPriceJSON } from '@aloft/shared-objects';
import { AloftPrice, isNonEmptyString, orUndefined } from '@aloft/toolkit-shared';

export function extractPrice(sale: Element): AloftPriceJSON | undefined {
  try {
    const rawPrice = sale.getAttribute('PropertySalesAmount') ?? undefined;
    if (!isNonEmptyString(rawPrice)) {
      return undefined;
    }
    return orUndefined(AloftPrice.fromDollarLike)(rawPrice)?.toJSON();
  } catch (e: unknown) {
    console.warn('Failed to parse price', e);
    return undefined;
  }
}
